var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography, } from "@material-ui/core";
import { Add, MoreVert } from "@material-ui/icons";
import { AdminLayout } from "frontend/src/pages/layouts";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { paths } from "frontend/src/pages/paths/index";
import { useEditUserNameAndEmail } from "frontend/src/domain/user/model";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { useCreateClient } from "frontend/src/domain/client/actions";
import { usePageModel } from "./model";
var UserMenu = function (_a) {
    var clientId = _a.clientId;
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var isOpen = Boolean(anchorEl);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { onClick: handleClick, size: "small" },
            React.createElement(MoreVert, null)),
        React.createElement(Menu, { anchorEl: anchorEl, keepMounted: true, open: isOpen, onClose: handleClose },
            React.createElement(MenuItem, { component: Link, to: paths.admin.clients.view(clientId) }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"))));
};
var Clients = React.memo(function (_a) {
    var clients = _a.clients;
    return (React.createElement(React.Fragment, null, clients.items.map(function (client) {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement(TableRow, { key: client.id },
            React.createElement(TableCell, null, (_a = client.user) === null || _a === void 0 ? void 0 : _a.name),
            React.createElement(TableCell, null, (_b = client.user) === null || _b === void 0 ? void 0 : _b.email),
            React.createElement(TableCell, null, (_c = client.russianLegalEntity) === null || _c === void 0 ? void 0 : _c.title),
            React.createElement(TableCell, null, client.contractNumber),
            React.createElement(TableCell, null, ((_d = client.musicLicenseInvoices) === null || _d === void 0 ? void 0 : _d.items.length) === 0 ? ("??") : (React.createElement(Typography, { color: Boolean((_e = client.musicLicenseInvoices) === null || _e === void 0 ? void 0 : _e.debt)
                    ? "error"
                    : "initial", variant: "body2" }, (_f = client.musicLicenseInvoices) === null || _f === void 0 ? void 0 : _f.debt))),
            React.createElement(TableCell, null, client.createdAt.slice(0, 10)),
            React.createElement(TableCell, null,
                React.createElement(UserMenu, { clientId: client.id }))));
    })));
});
var AddUserDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var _b = useEditUserNameAndEmail({
        name: "",
        email: "",
    }), name = _b.name, email = _b.email, validate = _b.validate, errors = _b.errors;
    var _c = __read(React.useState(""), 2), password = _c[0], setPassword = _c[1];
    var _d = __read(React.useState(null), 2), passwordError = _d[0], setPasswordError = _d[1];
    var onPasswordChange = function (evt) {
        return setPassword(evt.target.value);
    };
    var _e = useCreateClient(), createClient = _e.mutate, isClientCreated = _e.isSuccess, isCreatingClient = _e.isLoading;
    var submit = function (evt) {
        evt.preventDefault();
        if (password.length < 8) {
            setPasswordError("Минимальная длина пароля - 8 символов.");
        }
        else {
            setPasswordError(null);
        }
        if (validate() && password.length >= 8) {
            createClient({
                name: name.value,
                email: email.value,
                password: password,
            });
        }
    };
    var onUserNameChange = function (evt) {
        return name.set(evt.target.value);
    };
    var onEmailChange = function (evt) {
        return email.set(evt.target.value);
    };
    React.useEffect(function () {
        if (isClientCreated) {
            name.set("");
            email.set("");
            setPassword("");
            onClose();
        }
    }, [isClientCreated]);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, maxWidth: "sm", fullWidth: true },
        React.createElement(DialogTitle, null, "\u041D\u043E\u0432\u044B\u0439 \u043A\u043B\u0438\u0435\u043D\u0442"),
        React.createElement("form", { onSubmit: submit },
            React.createElement(DialogContent, null,
                React.createElement(TextField, { label: "Логин", value: name.value, onChange: onUserNameChange, error: Boolean(errors.name), helperText: errors.name, autoFocus: true, fullWidth: true }),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Почта", value: email.value, onChange: onEmailChange, error: Boolean(errors.email), helperText: errors.email, fullWidth: true })),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Пароль", value: password, type: "password", onChange: onPasswordChange, error: Boolean(passwordError), helperText: passwordError, fullWidth: true }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onClose, color: "primary" }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(ButtonLoader, { isLoading: isCreatingClient, color: "primary", type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
var AddUser = function () {
    var _a = __read(React.useState(false), 2), isOpen = _a[0], setOpen = _a[1];
    var open = function () { return setOpen(true); };
    var close = function () { return setOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(Button, { variant: "contained", color: "primary", endIcon: React.createElement(Add, null), onClick: open }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C")),
        ReactDOM.createPortal(React.createElement(AddUserDialog, { onClose: close, isOpen: isOpen }), document.body)));
};
var Page = function () {
    var _a = usePageModel(), clients = _a.clients, title = _a.title, username = _a.username, pagination = _a.pagination, sortBy = _a.sortBy;
    return (React.createElement(Box, null,
        React.createElement(AddUser, null),
        React.createElement(Box, { component: Paper, p: 2, mt: 2 },
            React.createElement(TextField, { fullWidth: true, label: "Логин или почта клиента", value: username.value, onChange: username.onChange }),
            React.createElement(Box, { mt: 1 },
                React.createElement(TextField, { fullWidth: true, label: "Юридическое лицо", value: title.value, onChange: title.onChange }))),
        React.createElement(Box, { component: Paper, mt: 1 },
            React.createElement(TableContainer, null,
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "\u041B\u043E\u0433\u0438\u043D"),
                            React.createElement(TableCell, null, "\u041F\u043E\u0447\u0442\u0430"),
                            React.createElement(TableCell, null, "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E"),
                            React.createElement(TableCell, null, "\u0414\u043E\u0433\u043E\u0432\u043E\u0440"),
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: sortBy.debt.active, onClick: sortBy.debt.onClick, direction: sortBy.debt.direction }, "\u0414\u043E\u043B\u0433")),
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: sortBy.registerDate.active, onClick: sortBy.registerDate.onClick, direction: sortBy.registerDate.direction }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D")),
                            React.createElement(TableCell, null))),
                    React.createElement(TableBody, null, clients ? (React.createElement(Clients, { clients: clients })) : (React.createElement(TableRowsSkeleton, { rows: pagination.rowsPerPage, columns: 7 }))))),
            clients && (React.createElement(TablePagination, { rowsPerPageOptions: [10, 25, 50], component: "div", count: clients.total, rowsPerPage: pagination.rowsPerPage, page: pagination.page, onPageChange: pagination.onChangePage, onRowsPerPageChange: pagination.onChangeRowsPerPage, labelRowsPerPage: "Клиентов на странице" })))));
};
export var ClientsPage = function () {
    return (React.createElement(AdminLayout, null,
        React.createElement(Page, null)));
};
